/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";

const TimelineDivider = () => {

    return (
        <div className='timeline-divider'>
            <div className='timeline-divider-top-line' />
            <div className='timeline-divider-circle' />
            <div className='timeline-divider-bottom-line' />
        </div>
    );
};

TimelineDivider.displayName = "TimelineDivider";
export { TimelineDivider };
